// Membership = the paid tier that turns the anticipatory assistant on.
//
// SETUP: create a $12/month recurring Price in the Stripe Dashboard and put its
// id here, or set VUE_APP_MEMBERSHIP_PRICE_ID at build time. Until a real price
// id is configured, the subscribe button is disabled (we never send a
// placeholder id to Stripe).
export const MEMBERSHIP_PRICE_ID =
  process.env.VUE_APP_MEMBERSHIP_PRICE_ID || "price_REPLACE_WITH_MEMBERSHIP_PRICE";

export const MEMBERSHIP_PRICE_DISPLAY = "$12";
export const MEMBERSHIP_PRICE_VALUE = 12; // numeric, for analytics event value
export const MEMBERSHIP_INTERVAL = "month";

export const MEMBERSHIP_BENEFITS = [
  "Your assistant keeps an eye on the people you've added",
  "Proactive postcards when you've gone quiet — drafted in your voice, printed and posted, included",
  "Gift ideas before birthdays & anniversaries (you approve; gifts billed per item)",
  "A weekly relationship digest, on demand or in your inbox",
];

// True once a real Stripe price id has been wired (not the placeholder).
export const isMembershipConfigured = () =>
  !!MEMBERSHIP_PRICE_ID && !MEMBERSHIP_PRICE_ID.includes("REPLACE");

// Stripe subscription statuses that count as an active, entitled membership.
const ACTIVE_STATUSES = new Set(["active", "trialing"]);
export const isActiveMembershipStatus = (status) => ACTIVE_STATUSES.has(status);
